import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  FetchCsvTemplatesResponse,
  FetchCsvTemplateResponse,
  FetchCsvTemplateNameOptionsResponse,
  CreateCsvTemplateResponse,
  UpdateCsvTemplateResponse,
  DeleteCsvTemplateResponse,
} from '../../../../types/b2tRatibiPlus';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';
import { PaginatedRequest } from '../../../../types/api';

export const fetchCsvTemplates = createAsyncThunk<FetchCsvTemplatesResponse, PaginatedRequest>(
  'csvTempletes/fetch-all',
  async (data) => {
    const response = await b2bThriftPlan.fetchCsvTemplates(data);
    return response;
  },
);

export const fetchCsvTemplate = createAsyncThunk<FetchCsvTemplateResponse, number>(
  'csvTempletes/fetch-one',
  async (id) => {
    const response = await b2bThriftPlan.fetchCsvTemplate(id);
    return response;
  },
);

export const fetchCsvTemplateNameOptions = createAsyncThunk<FetchCsvTemplateNameOptionsResponse>(
  'csvTempletes/fetch-name-options',
  async () => {
    const response = await b2bThriftPlan.fetchCsvTemplateNameOptions();
    return response;
  },
);

export const createCsvTemplate = createAsyncThunk<CreateCsvTemplateResponse, { name: string; file: File }>(
  'csvTempletes/create',
  async ({ name, file }) => {
    const response = await b2bThriftPlan.createCsvTemplate({ name, file });
    return response;
  },
);

export const updateCsvTemplate = createAsyncThunk<UpdateCsvTemplateResponse, { id: number; file: File }>(
  'csvTempletes/update',
  async ({ id, file }) => {
    const response = await b2bThriftPlan.updateCsvTemplate(id, file);
    return response;
  },
);

export const deleteCsvTemplate = createAsyncThunk<DeleteCsvTemplateResponse, number>(
  'csvTempletes/delete',
  async (id) => {
    const response = await b2bThriftPlan.deleteCsvTemplate(id);
    return response;
  },
);
